<template>
    <div class="page-content">
        <!-- <div class="card">
        <div class="card-body">
          <h5>Estimated Usage</h5>
          <hr/>
          <el-alert title="Disclaimer" effect="dark" show-icon :closable="false" type="info">
            <p>
              1. Semua data Insight terdapat kemungkinan berbeda dari yang ditampilkan pada perhitungan billing usage bulanan.<br/>
              2. Billing usage & Faktur Pajak mengikuti cut off finance di akhir bulan pukul 24.00.<br/>
              3. Data Insight dibuat untuk membantu Anda memperkirakan jumlah tagihan yang telah Anda gunakan.<br/>
              4. Harga yang digunakan untuk menghitung estimasi penggunaan adalah harga untuk nomor Indonesia (termasuk PPn).<br/>
            </p>
          </el-alert>
        </div>
      </div> -->
        <div class="row mt-2">
            <div class="col-md-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h5 class="mb-4">Estimated Usage</h5>
                        <div class="d-flex">
                            <el-date-picker v-model="filter.date_range" type="daterange" size="small"
                                :picker-options="date_picker_options" @change="dateCheck" range-separator="To"
                                start-placeholder="Start date" end-placeholder="End date">
                            </el-date-picker> &nbsp;
                            <el-select size="small" v-model="filter.status_filter" placeholder="Select">
                                <el-option v-for="item in statusFilterOptions" :key="item.value" :label="item.text"
                                    :value="item.value">
                                </el-option>
                            </el-select> &nbsp;
                            <el-button :loading="loading.table" @click="filter.page = 1; getReportList();" size="small"
                                class="btn-default" icon="el-icon-search">Search</el-button>
                            <el-button :loading="loading.table" @click="downloadReport();" size="small"
                                class="btn-primary" icon="el-icon-download">Download</el-button>
                        </div>
                        <hr />
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Recipient</th>
                                        <th>Category</th>
                                        <th>Source of Fund</th>
                                        <th>Price</th>
                                        <!-- <th>Balance</th> -->
                                        <th>Message ID</th>
                                        <th>Status</th>
                                        <th>Ref. Number</th>
                                    </tr>
                                </thead>
                                <tbody v-loading="loading.table">
                                    <tr v-for="data in list" :key="data.id">
                                        <td>{{ data.created_at_str ? data.created_at_str : '-' }}</td>
                                        <td>{{ data.sent_at_str }}</td>
                                        <td>{{ data.recipient_raw }}</td>
                                        <td>{{ data.pricing_category_str }}</td>
                                        <td>{{ data.sof_str }}</td>
                                        <td>{{ data.price_str }}</td>
                                        <!-- <td>{{ data.balance_after_str }}</td> -->
                                        <td>{{ data.msg_id }}</td>
                                        <td>
                                            <el-tag size="mini" :type="data.status_color">
                                                {{ data.status_str }}
                                            </el-tag>
                                        </td>
                                        <td>{{ data.refference_number }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <b-pagination v-if="count > per_page" v-model="currentPage" :total-rows="count"
                                :per-page="per_page" />
                            <el-empty v-if="!count" description="No data"></el-empty>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import reportApi from '../../../api/reports';
import popupErrorMessages from '../../../library/popup-error-messages';

export default {
  name: 'ReportSessionDetailEmail',
  metaInfo: {
    title: 'Report Session Email',
  },
  data() {
    return {
      list: [],
      count: 0,
      pricing_category: {
        regular: 'REGULAR',
      },
      pricing_category_short: {
        incoming_call: 'Incoming call',
        outgoing_call: 'Outgoing call',
      },
      sof: {
        balance: 'Balance',
        postpaid: 'Postpaid',
      },
      per_page: 50,
      loading: {
        table: true,
        analytics: false,
      },
      filter: {
        page: this.$route.query.page || 1,
        date_range: [
                    this.$route.query?.start_date || moment(),
                    this.$route.query?.end_date || moment(),
        ],
        status_filter: this.$route.query?.status || '',
      },
      statusFilterOptions: [
        {
          value: '',
          text: 'All',
        },
        {
          value: 'success',
          text: 'Success',
        },
        {
          value: 'failed',
          text: 'Failed',
        },
      ],
      date_picker_options: {
        disabledDate: (time) => {
          const today = moment();
          const diff = today.diff(moment(time), 'd');
          if (diff > 90 || diff < 0) {
            return true;
          }
          if (diff === 0) {
            if (today.isSame(moment(time), 'd') === false) {
              return true;
            }
          }
          return false;
        },
        shortcuts: [
          {
            text: 'This week',
            onClick(picker) {
              const start = moment().startOf('week').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'This month',
            onClick(picker) {
              const start = moment().startOf('month').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last week',
            onClick(picker) {
              const start = moment().subtract(1, 'week').startOf('week').format();
              const end = moment().subtract(1, 'week').endOf('week').format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last month',
            onClick(picker) {
              const start = moment().subtract(1, 'month').startOf('month').format();
              const end = moment().subtract(1, 'month').endOf('month').format();
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show();
    await this.getReportList();
    loader.hide();
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
    currentPage: {
      get() {
        return this.filter.page;
      },
      set(val) {
        this.filter.page = val;
        this.getReportList();
      },
    },
  },
  methods: {
    dateCheck() {
      const [start_date, end_date] = this.filter.date_range;
      const minTime = moment(start_date);
      const maxTime = moment(end_date);
      const diff = maxTime.diff(moment(minTime), 'd');
      if (diff > 30) {
        this.$message({
          title: this.$t('general.error.general'),
          type: 'warning',
          message: 'Reporting period that can be selected for 31 days',
          duration: 20 * 100,
          showClose: true,
        });
        this.filter.date_range = [start_date, start_date];
      }
    },
    async getReportList() {
      this.dateCheck();
      const options = {
        page: this.filter.page.toString(),
        per_page: this.per_page.toString(),
        start_date: moment(this.filter.date_range[0]).format('YYYY-MM-DD'),
        end_date: moment(this.filter.date_range[1]).format('YYYY-MM-DD'),
        status_filter: this.filter.status_filter,
      };
      this.loading.table = true;
      const { data } = await reportApi.sessionList({
        workspace_id: this.activeWorkspace._id,
        channel_id: this.$route.params.channel_id,
        query: options,
      }).catch((err) => console.log(err));
      data.rows = data.rows.map((v) => {
        v.created_at_str = moment(v.created_at).format('DD MMM YYYY, HH:mm');
        v.sent_at_str = v.sent_at ? moment(v.sent_at).format('DD MMM YYYY, HH:mm') : '';
        if (Array.isArray(v.to)) {
          v.to = v.to.join(', ');
        }
        v.recipient_raw = v.to;
        const pricingCategory = this.pricing_category[v.pricing_category?.toLowerCase()];
        v.pricing_category_str = pricingCategory ?? '';

        v.balance_after_str = '-';
        if (['balance', 'postpaid'].includes(v.source_of_fund) && v.balance_after) {
          v.balance_after_str = v.balance_after.toLocaleString('id-ID');
          if (v.source_of_fund === 'balance') {
            v.balance_after_str = `Rp. ${v.balance_after_str}`;
          } else {
            v.balance_after_str += ' quota(s)';
          }
        }
        v.refference_number = v.refference_number.split(':')[0];
        if (['balance', 'postpaid'].includes(v.source_of_fund)) {
          v.price_str = `Rp. ${(v.price || '').toLocaleString('id-ID')}`;
        } else {
          v.price_str = `${v.price} quota`;
        }
        v.sof_str = this.sof[v.source_of_fund] || '-';
        v.status_str = ['waiting', 'sent', 'delivered'].includes(v.status) ? 'Success' : 'Failed';
        v.status_color = ['waiting', 'sent', 'delivered'].includes(v.status) ? 'success' : 'danger';
        return v;
      });
      ({ rows: this.list, count: this.count } = data);
      this.loading.table = false;
    },
    async downloadReport() {
      this.$confirm(this.$t('report.confirm_download'), this.$t('general.confirmation'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            this.loading.table = true;
            const options = {
              page: this.filter.page.toString(),
              per_page: this.per_page.toString(),
              start_date: moment(this.filter.date_range[0]).format('YYYY-MM-DD'),
              end_date: moment(this.filter.date_range[1]).format('YYYY-MM-DD'),
              status_filter: this.filter.status_filter,
            };
            const response = await reportApi.downloadSessionList({
              workspace_id: this.activeWorkspace._id,
              channel_id: this.$route.params.channel_id,
              query: options,
            }).catch(() => { });
            this.loading.table = false;
            instance.confirmButtonLoading = false;
            await popupErrorMessages(response);
            this.$message({
              title: this.$t('general.success'),
              type: 'success',
              message: this.$t('general.waiting_download'),
              duration: 10 * 1000,
              showClose: true,
            });
          }
          cb();
        },
      });
    },
  },
};
</script>
